<template>
  <li>
    <a
      :href="href"
      :class="itemClasses"
      :disabled="disabled"
      :target="link ? target : null"
      :rel="link ? 'noopener noreferrer' : null"
      data-testid="bs-dropdown-item"
      @click="handleClick"
    >
      <slot />
    </a>
  </li>
</template>

<script>
export default {
  name: 'BsDropdownItem',
  inject: ['dropdownInstance'],
  props: {
    href: {
      type: String,
      default: '#',
    },
    link: {
      type: Boolean,
      default: false,
    },
    target: {
      type: String,
      default: '_self',
      validator: (value) => ['_self', '_blank', '_parent', '_top'].includes(value),
    },
    active: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: null,
    },
    buttonClass: {
      type: [String, Array, Object],
      default: null,
    },
  },
  computed: {
    itemClasses() {
      const classes = ['dropdown-item'];

      if (this.active) {
        classes.push('active');
      }
      if (this.disabled) {
        classes.push('disabled');
      }
      if (this.variant) {
        classes.push(`dropdown-item-${this.variant}`);
      }
      if (this.buttonClass) {
        classes.push(this.buttonClass);
      }

      return classes;
    },
  },
  methods: {
    handleClick(event) {
      if (this.disabled) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      if (!this.link) {
        event.preventDefault();
      }

      this.$emit('click', event);
      
      // Close dropdown after item click (if not a link)
      if (!this.link && this.href === '#' && this.dropdownInstance) {
        this.$nextTick(() => {
          this.dropdownInstance.hide();
        });
      }
    },
  },
};
</script>

<style scoped>
.dropdown-item.disabled {
  pointer-events: none;
  opacity: 0.65;
}
</style>